<div class="d-flex border-dark-top">
  <div *ngFor="let tab of tabs; let i = index"
    class="p-2 flex-fill d-flex justify-content-center align-items-center disable-select"
    [ngClass]="(tabSelect == tab)?'menu-item-active':'menu-item'" (click)="changeTab(tab)">
    <i class="{{tab?.icon}} mr-1"></i>
    <span>{{tab?.name}}</span>
  </div>
</div>
<app-data-bank-type *ngIf="tabSelect?.id == permission.data_bank_type_id"></app-data-bank-type>
<app-data-bank-list *ngIf="tabSelect?.id == permission.data_bank_id"></app-data-bank-list>